var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPieChart(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 25,
    height: 24,
    fill: "currentColor",
    viewBox: "0 0 25 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "pie-chart__Property 1=Pie Chart",
    className: "pie-chart__Property pie-chart__1=Pie pie-chart__Chart"
  }, /*#__PURE__*/React.createElement("g", {
    id: "pie-chart__Vector",
    className: "pie-chart__Vector"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#919EAB",
    fillOpacity: 0.16,
    d: "M11.374 3.659a.112.112 0 0 0-.113-.113 9.206 9.206 0 1 0 9.319 9.319.112.112 0 0 0-.113-.113h-8.98a.113.113 0 0 1-.113-.114v-8.98Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#596773",
    d: "M10.745 4.198A8.578 8.578 0 0 0 5.31 18.816a8.577 8.577 0 0 0 14.617-5.434h-8.438a.744.744 0 0 1-.743-.744v-8.44Zm.638 8.484a.112.112 0 0 0 .06.06l.045.01h8.98c.062 0 .113.05.112.113l-.011.333a9.205 9.205 0 0 1-1.54 4.668l-.195.28a9.207 9.207 0 0 1-8.92 3.695l-.336-.06a9.207 9.207 0 0 1-7.16-6.9l-.073-.333a9.208 9.208 0 0 1 .4-5.002l.124-.317a9.208 9.208 0 0 1 3.11-3.938l.28-.194a9.206 9.206 0 0 1 5.002-1.55.11.11 0 0 1 .113.112v8.98l.01.043Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0054EC",
    fillOpacity: 0.16,
    d: "M21.915 12.116a.24.24 0 0 0 .243-.223c.073-1.198-.272-3.156-.704-4.193a9.099 9.099 0 0 0-1.985-2.953 9.162 9.162 0 0 0-2.971-1.973c-1.016-.418-3.265-.756-4.154-.73-.124.004-.213.109-.213.233l-.001 9.588c0 .139.113.252.252.252h9.533Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#011E60",
    d: "M12.332 12.112a.252.252 0 0 1-.202-.247V2.277c0-.124.09-.229.214-.233.89-.026 3.138.312 4.154.73a9.162 9.162 0 0 1 2.97 1.973A9.099 9.099 0 0 1 21.455 7.7c.432 1.037.777 2.995.704 4.193l-.023.09a.245.245 0 0 1-.22.133h-9.533l-.05-.004Zm.427-.625h8.777c-.005-.48-.061-1.06-.161-1.645-.127-.744-.31-1.441-.502-1.9a8.473 8.473 0 0 0-1.848-2.749 8.535 8.535 0 0 0-2.767-1.837c-.44-.18-1.198-.361-1.987-.493a14.983 14.983 0 0 0-1.512-.18v8.804Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPieChart);
export default __webpack_public_path__ + "static/media/pie_chart.734a596d1a51c5a082693085b189af8e.svg";
export { ForwardRef as ReactComponent };